import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Alert, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { changePasswordApiCall } from "../../utils/Apicalls";
import SpinnerShow from "../../components/Spinner";
import Header from "../../components/common/header/Header";
import Footer from "../../components/common/footer/Footer";
import "./myprofile.css";

function MyProfilePage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msgType, setMsgType] = useState("");
  const [error, setError] = useState("");

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const validateForm = () => {
    if (!password) {
      setError("Please enter a password");
      return false;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters long");
      return false;
    }
    return true;
  };

  const onSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    setLoading(true);
    setError("");
    try {
      const result = await changePasswordApiCall({ password });
      setLoading(false);
      if (result?.status) {
        setMsgType("success");
        setPassword("");
        // Remove the changePassword flag from localStorage
        localStorage.removeItem("userType");
      } else {
        setError(result?.message || "Failed to update password. Please try again.");
      }
    } catch (err) {
      setLoading(false);
      setError("An error occurred while updating your password. Please try again later.");
      console.error("Profile error:", err);
    }
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="profile-page-wrapper">
      <Header />
      
      <div className="password-update-container">
        <div className="password-update-card">
          {loading && (
            <div className="spinner-container">
              <SpinnerShow />
            </div>
          )}
          
          {error && !loading && (
            <div className="password-error-alert">
              <Alert severity="error">{error}</Alert>
            </div>
          )}
          
          {!loading && msgType === "success" && (
            <div className="success-message">
              <Alert severity="success">Password Updated Successfully!</Alert>
              <Button 
                variant="contained" 
                color="primary" 
                onClick={() => navigate("/home")} 
                className="go-home-button"
              >
                Go to Home
              </Button>
            </div>
          )}
          
          {!loading && !msgType && (
            <>
              <div className="password-field-container">
                <label htmlFor="new-password" className="password-label">
                  New Password <span className="required">*</span>
                </label>
                <div className="password-input-container">
                  <TextField
                    id="new-password"
                    variant="outlined"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter new password"
                    type={showPassword ? "text" : "password"}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleTogglePassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
              
              <button className="update-password-button" onClick={onSubmit}>
                Update Password
              </button>
              
              <button className="back-to-login-button" onClick={handleBackToLogin}>
                Back to Login
              </button>
            </>
          )}
        </div>
      </div>
      
      <Footer />
    </div>
  );
}

export default MyProfilePage;


